var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ButtonAFY, icons, InformationAFY, ModalComponentAFY, sizes, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useStyles } from "../../../style/insurancePoliciesSummary.style";
export var HistoryModalView = function (_a) {
    var open = _a.open, onClose = _a.onClose, loading = _a.loading, logEntries = _a.logEntries;
    var classes = useStyles();
    return (_jsx(ModalComponentAFY, __assign({ openModal: open, backgroundColor: "#ffffff", onClose: onClose, border: 0, minWidthModal: "600px", padding: 30, modalHeight: "70vh", modalHeightII: "70vh" }, { children: _jsxs("div", __assign({ style: { display: "flex", flexDirection: "column", height: "100%" } }, { children: [_jsx("h2", __assign({ className: classes.title }, { children: "Historial" })), _jsx(InformationAFY, { backgroundColor: "#F5F5F5", colorText: "#666666", description: "Bit\u00E1cora de eventos de la cotizaci\u00F3n/p\u00F3liza", icon: icons.Info, iconColor: "#3A56A1", iconSize: sizesIcon.standard }), _jsx("div", __assign({ style: {
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                        marginTop: "16px",
                        paddingRight: "8px",
                    } }, { children: loading ? (_jsx("p", __assign({ style: { color: "#666666", margin: 0 } }, { children: "Cargando bit\u00E1cora..." }))) : (logEntries === null || logEntries === void 0 ? void 0 : logEntries.length) ? (logEntries.map(function (line, index) { return (_jsx("div", __assign({ style: {
                            fontSize: "14px",
                            color: "#333333",
                            lineHeight: "1.5",
                            padding: "8px 0",
                            borderBottom: "1px solid #EEEEEE",
                        } }, { children: line }), index)); })) : (_jsx("p", __assign({ style: { color: "#666666", margin: 0 } }, { children: "Sin eventos registrados." }))) })), _jsx("div", __assign({ style: {
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "16px",
                    } }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Cerrar", backgroundColor: "rgb(29, 52, 254)", onClick: onClose }) }))] })) })));
};
